import React from 'react';
import Shimmer from './Shimmer';

const HeroShimmer = () => (
    <div className="relative w-full h-96 bg-gray-100">
        <div className="absolute inset-0 p-8 flex flex-col justify-center items-center space-y-4">
            <Shimmer className="h-8 w-3/4 max-w-2xl rounded"/>
            <Shimmer className="h-4 w-2/3 max-w-xl rounded"/>
            <div className="flex space-x-4 mt-6">
                <Shimmer className="h-10 w-32 rounded"/>
                <Shimmer className="h-10 w-32 rounded"/>
            </div>
        </div>
    </div>
);

export default HeroShimmer;